import {
  Accordion as MUIAccordion,
  AccordionSummary as MUIAccordionSummary,
  AccordionDetails as MUIAccordionDetails,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { richTextResolver } from '@widget/storyblok';
import { theme } from '@widget/toolbox/style/theme';

import Typography from '@components/Typography';

import type { FAQItemData } from './types';
import type { FC } from 'react';

export type FAQItemProps = FAQItemData;

export const FAQItem: FC<FAQItemProps> = ({ title, content }) => {
  return (
    <MUIAccordion
      square
      disableGutters
      sx={{
        boxShadow: 'none',
        ':before': {
          backgroundColor: 'transparent',
        },
        borderBottom: `1px solid ${theme.palette.colors.primary}`,
      }}
    >
      <MUIAccordionSummary
        expandIcon={<ExpandMoreIcon className="accordion-icon" />}
        sx={{
          minHeight: 80,
        }}
      >
        <Box display="flex" flex="1 1 100%" alignItems="center" justifyContent="flex-start" gap={2}>
          <Typography type="H3" className="title">
            {title}
          </Typography>
        </Box>
      </MUIAccordionSummary>
      <MUIAccordionDetails>
        <Box display="flex" flexDirection="column">
          <Typography
            type="B2"
            className="content"
            dangerouslySetInnerHTML={{ __html: richTextResolver.render(content) }}
          />
        </Box>
      </MUIAccordionDetails>
    </MUIAccordion>
  );
};
